require('aframe');
require('aframe-uipack-component');
require('aframe-environment-component');
require('./components/tree-components.js');
require('./components/tree-viz.js');




